<app-button>
  <app-icon icon="assets/arrow-left.svg"></app-icon>
  Vorige
</app-button>
